module.exports = __webpack_public_path__ + "src/components/assets/icon-optician-category.893abd6b4f0f10fcfee87c617bd89295.svg";